















import { defineComponent, ref } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'SelectableRatingStarsBar',
  props: {
    value: {
      type: Number,
      required: false,
      validator: (value) => value >= 0 && value <= 5,
      default: 0
    },
    isInvalid: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const shownValue = ref(props.value || 0);

    const indexCoverage = (index: number) => {
      // vue for is 1 indexed so we need to subtract 1
      const zeroIndex = index - 1;
      if (zeroIndex < Math.floor(shownValue.value)) return 1;
      if (zeroIndex >= Math.ceil(shownValue.value)) return 0;
      // show half a star for any decimal value
      return 0.5;
    };

    const handleHover = (index: number) => {
      shownValue.value = index;
    };

    const handleUnhover = () => {
      shownValue.value = props.value;
    };

    const handleClick = (index: number) => {
      emit('input', index);
      shownValue.value = index;
    };

    return {
      indexCoverage,
      handleHover,
      handleUnhover,
      handleClick
    };
  }
});
